import { render, staticRenderFns } from "./PackingPopup.vue?vue&type=template&id=47e9feda&"
import script from "./PackingPopup.vue?vue&type=script&lang=js&"
export * from "./PackingPopup.vue?vue&type=script&lang=js&"
import style0 from "./PackingPopup.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports